// extracted by mini-css-extract-plugin
export var body = "_hc-8";
export var button = "_hc-0";
export var closeButton = "_hc-5";
export var content = "_hc-3";
export var empty = "_hc-f";
export var grid = "_hc-c";
export var header = "_hc-4";
export var icon = "_hc-1";
export var option = "_hc-d";
export var optionSelected = "_hc-e";
export var overlay = "_hc-2";
export var searchIcon = "_hc-a";
export var searchInput = "_hc-b";
export var searchWrapper = "_hc-9";
export var title = "_hc-6";
export var visuallyHidden = "_hc-7";